import {Component, Input, OnInit} from '@angular/core';

enum SegmentPlace {
    MIN = 'min',
    MID = 'mid',
    MAX = 'max'
}

interface ISegment {
    value: number;
    id: SegmentPlace;
}

@Component({
    selector: 'lib-progressbar-stacked',
    templateUrl: './progressbar-stacked.component.html',
    styleUrls: ['./progressbar-stacked.component.scss']
})
export class ProgressbarStackedComponent implements OnInit {
    @Input() segments: ISegment[] = [];

    @Input() barTitle: string | null = null;
    @Input() values: number[] = [];

    success: number[] = [];
    other: number[] = [];
    constructor() {
    }

    ngOnInit(): void {
        this.success = [this.values[0],  (100 - this.values[0])];
        this.other = [this.values[1], this.values[2], this.values[3], this.values[0]];
        this.segments = [
            {
                id: SegmentPlace.MIN,
                value: this.values[0]
            },
            {
                id: SegmentPlace.MID,
                value: this.values[1]
            },
            {
                id: SegmentPlace.MAX,
                value: this.values[2]
            },
            {
                id: SegmentPlace.MAX,
                value: this.values[3]
            }
        ];
    }

}
